var $ = require("jquery");
require("slick-carousel/slick/slick.scss");
require("slick-carousel");

jQuery(function() {
  $(".slider-blocks__list").slick({
    centerMode: true,
    infinite: true,
    arrows: false,
    dots: true,
    lazyLoad: "ondemand",
    slidesToShow: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          infinite: false
        }
      }
    ]
  });
});
